import { createElement, useState } from 'react';

import { anchorAtPointer, Menu } from '@/components/ui/Menu.web';
import type { AggregateFunction } from '@/lib/databases/values';

import {
  CALCULATE_MENU_MIN_WIDTH,
  CalculateMenuPanel,
  hasFooterAggregates,
} from './CalculateMenuPanel.web';

export { hasFooterAggregates };

type FooterCalculateMenuProps = {
  columnType: string;
  selectedFn: AggregateFunction | undefined;
  resultDisplay: string | undefined;
  disabled?: boolean;
  onSelect: (fn: AggregateFunction | null) => void;
};

export function FooterCalculateMenu({
  columnType,
  selectedFn,
  resultDisplay,
  disabled,
  onSelect,
}: FooterCalculateMenuProps) {
  const [open, setOpen] = useState(false);
  const [anchor, setAnchor] = useState<{ left: number; top: number; width?: number } | null>(
    null,
  );

  function openMenu(clientX: number, clientY: number) {
    if (disabled) {
      return;
    }
    setAnchor(anchorAtPointer(clientX, clientY, { above: true }));
    setOpen(true);
  }

  function closeMenu() {
    setOpen(false);
  }

  function selectFn(fn: AggregateFunction | null) {
    onSelect(fn);
    closeMenu();
  }

  return createElement(
    'div',
    { className: 'cs-db-footer-calculate' },
    createElement(
      'button',
      {
        type: 'button',
        className: `cs-db-footer-calculate-trigger${
          selectedFn ? ' cs-db-footer-calculate-trigger--active' : ''
        }`,
        disabled,
        title: 'Calculate',
        onMouseDown: (e: MouseEvent) => e.stopPropagation(),
        onClick: (e: MouseEvent) => {
          e.stopPropagation();
          if (open) {
            closeMenu();
          } else {
            openMenu(e.clientX, e.clientY);
          }
        },
      },
      selectedFn && resultDisplay != null && resultDisplay !== ''
        ? createElement('span', { className: 'cs-db-footer-value' }, resultDisplay)
        : createElement('span', { className: 'cs-db-footer-calculate-hint' }, 'Calculate'),
    ),
    createElement(Menu, {
      open,
      anchor,
      minWidth: CALCULATE_MENU_MIN_WIDTH,
      dataAttribute: 'cs-footer-calculate',
      onClose: closeMenu,
      children: createElement(CalculateMenuPanel, {
        columnType,
        selectedFn,
        submenuSide: 'left',
        onSelect: selectFn,
      }),
    }),
  );
}
